<template>
    <h2 class="d-inline">{{ $trans.get('__JSON__.Worktime checks') }}
      <div class="pt-1 pb-1 ps-2 pe-2 bg-danger text-white rounded-1 badge" style="font-size: 0.7rem; transform: translateY(-0.7rem);">
        {{ getCountWorktimealarms() }} </div> </h2>
  <table class="table table-striped hover-zoom">
    <thead>
      <tr>
        <th role="button" @click.prevent="sortColumn = 'employee'">{{ $trans.get('__JSON__.Employee') }}
          <i v-if="sortColumn == 'employee'" class="fa fa-sort-asc"></i>
        </th>
        <th role="button" @click.prevent="sortColumn = 'team'">{{ $trans.get('__JSON__.Team') }}
          <i v-if="sortColumn == 'team'" class="fa fa-sort-asc"></i>
        </th>
        <th role="button" @click.prevent="sortColumn = 'warning'">{{ $trans.get('__JSON__.Warning') }}
          <i v-if="sortColumn == 'warning'" class="fa fa-sort-asc"></i>
        </th>
        <th>{{ $trans.get('__JSON__.Planned') }}</th>
        <th>{{ $trans.get('__JSON__.Actual') }}</th>
        <!-- <th>{{ $trans.get('__JSON__.out at') }}</th> -->
        <th>{{ $trans.get('__JSON__.Breaktime') }}</th>
        <th class="w-20">{{ $trans.get('__JSON__.Actions') }}</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="worktimealarm in sortedWorktimeAlarms" :key="worktimealarm.id">
        <td>
          <div>{{ worktimealarm.employee.lastname }}, {{ worktimealarm.employee.forename }} ({{
          worktimealarm.employee.employer.name }})</div>
        </td>
        <td>
          <div>{{ worktimealarm.employee.team?.name }}</div>
        </td>
        <td>
          <div>
            <span v-if="worktimealarm.type == 1">{{ $trans.get("__JSON__.Too early") }}</span>
            <span v-if="worktimealarm.type == 2">{{ $trans.get("__JSON__.Too late") }}</span>
            <span v-if="worktimealarm.type == 3">{{ $trans.get("__JSON__.Too much hours") }}</span>
            <span v-if="worktimealarm.type == 4">{{ $trans.get("__JSON__.No mandatory break") }}</span>
            <span v-if="worktimealarm.type == 5">{{ $trans.get("__JSON__.Break to short") }}</span>
            <span v-if="worktimealarm.type == 6">{{ $trans.get("__JSON__.no 15 minutes or longer break") }}</span>
            <span v-if="worktimealarm.type == 7">{{ $trans.get("__JSON__.missing") }}</span>
          </div>
        </td>
        <td>
          <div>
            <i class="fa fa-warning text-danger" v-tooltip title="Warnung älter als ein Tag!"
              v-if="worktimealarm.warn"></i>
              {{ formatDate(worktimealarm.start_at) }} &nbsp; {{ secondsToMinutes(worktimealarm.workseconds) }}
          </div>
        </td>
        <td>
          <div>
            {{ formatDate(worktimealarm.in_at) }} &nbsp; {{ secondsToMinutes(worktimealarm.worked_seconds) }}
          </div>
        </td>
        <!-- <td>
          <div>
            {{ formatDate(worktimealarm.out_at) }}{{ worktimealarm.worked_seconds }}
          </div>
        </td> -->
        <td>
          <div>
            {{ secondsToMinutes(worktimealarm?.break_time_seconds) }}
          </div>
        </td>
        <td>
          <div>
            <button class="btn btn-success me-2" @click="okAndRemove(worktimealarm)"><i
                class="fa-solid fa-check"></i></button>
            <button v-if="worktimealarm.type == 1" class="btn btn-danger me-2"
              @click="adjustToStart(worktimealarm)" v-tooltip
              :title="$trans.get('__JSON__.Adjust to planned time')"><i class="fa-solid fa-xmark"></i></button>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import getWorktimeAlarms from "../composables/getWorktimeAlarms";
export default {
  name: "WorktimeAlarms",
  components: {
  },
  props: {
    //location_id: Number,
    monitor_others: Boolean,
    view_locations: Object,
  },
  setup(props) {
    //const location_id = props.location_id;
    const { worktimealarms, worktimealarms_error, loadWorktimeAlarms, alarmOK } = getWorktimeAlarms();
    loadWorktimeAlarms(props.monitor_others, props.view_locations);

    return {
      worktimealarms_error,
      worktimealarms,
      alarmOK,
      loadWorktimeAlarms,
    };
  }, 
  data() {
        return {
            sortColumn: 'warning'
        };
    },
  created() {
        let refreshtime =  600000 + Math.floor(Math.random() * 120000);
        setInterval(this.refreshData,refreshtime)
    },
  computed: {

    sortedWorktimeAlarms() {
      // Div im Blade verstecken, wenn es keine BEMs gibt.
      if (!this.worktimealarms) {
        $('#worktimeAlarmsContainer').css('display', 'none');
        return null;
      }

      if (this.worktimealarms.length == 0) {
        $('#worktimeAlarmsContainer').css('display', 'none');
        return null;
      }

      $('#worktimeAlarmsContainer').css('display', 'block');
      return this.worktimealarms.sort(this.compareWorktimeAlarms);
    }
  },
  methods: {
    okAndRemove(worktimealarm) {
      this.alarmOK(worktimealarm, false);

      this.worktimealarms = this.worktimealarms.filter(function (value, index, arr) {
        return value.id != worktimealarm.id;
      });

    },
    adjustToStart(worktimealarm) {
      this.alarmOK(worktimealarm, true);

      this.worktimealarms = this.worktimealarms.filter(function (value, index, arr) {
        return value.id != worktimealarm.id;
      });

    },
    compareWorktimeAlarms(a, b) {
            if (this.sortColumn == 'warning') {
                if (a.type == b.type) {
                    return 0;
                }
                if (a.type < b.type) {
                    return -1;
                }
                return 1;
            }

            if (this.sortColumn == 'team') {
                if (a.employee.team_id == b.employee.team_id) {
                    return 0;
                }
                if (a.employee.team_id < b.employee.team_id) {
                    return -1;
                }
                return 1;
            }

            if (this.sortColumn == 'employee') {
                if (a.employee.lastname > b.employee.lastname) {
                    return 1;
                }
                if (a.employee.lastname < b.employee.lastname) {
                    return -1;
                }
                if (a.employee.forename > b.employee.forename) {
                    return 1;
                }
                if (a.employee.forename < b.employee.forename) {
                    return -1;
                }
                if (a.type > b.type) {
                    return 1;
                }
                if (a.type < b.type) {
                    return -1;
                }
                return 0;
            }
            return 0;
        },
    getCountWorktimealarms() {
            if (!this.sortedWorktimeAlarms) {
                return counted = 0;
            }
            let counted = this.sortedWorktimeAlarms.length;
            return counted;
        },
    formatDate(dateString) {

      if(dateString == null) {
        return null;
      }
            const date = new Date(dateString);

            return date.toISOString().slice(0, 10) + ', ' + date.toLocaleTimeString();
        },
    secondsToMinutes(seconds) {
      if(seconds == null) {
        return null;
      }
      var calculatedTime = new Date( null );
      calculatedTime.setSeconds( seconds );
      var newTime = calculatedTime.toISOString().slice( 11, 19 );
        return newTime;
    },
    refreshData() {
        this.loadWorktimeAlarms(this.monitor_others, this.view_locations);
    },
  }
}
</script>

<style></style>
